export default [{
  mainButton: {
    name: 'staff',
    label: 'Staff',
    goTo: '/staff',
    tooltip: 'Everything related to staff'
  },
  fastButtons: [{
    name: 'staffAdd',
    label: 'add staff',
    goTo: '?modal=staff-add'
  }, {
    name: 'staffFilters',
    label: 'filter table',
    goTo: '?modal=timatableStaffFilter'
  }]
}, {
  mainButton: {
    name: 'autoscheduling',
    label: 'Auto<br>scheduling',
    goTo: '?modal=autoscheduling',
    tooltip: 'Auto-scheduling for employees and settings'
  },
  fastButtons: [{
    name: 'departments',
    label: 'department parameters',
    goTo: '?modal=DepSettings~currentDep'
  }]
}, {
  mainButton: {
    name: 'manualChanges',
    label: 'Manual<br>changes',
    tooltip: 'Manual changes to staff schedule',
    menu: [{
      name: 'deleteShifts',
      label: 'Delete schedule',
      goTo: '?modal=delete-schedule',
      metrikaIdReach: 'btn_delete_shifts'
    }, {
      name: 'timetableDuplicateSchedule',
      label: 'Duplicate schedule',
      goTo: '?modal=duplicate-schedule',
      metrikaIdReach: 'btn_timetable_duplicate_schedule'
    }, {
      name: 'timetableDuplicateScheduleMonth',
      label: 'Copying from month to month',
      goTo: '?modal=duplicate-schedule-month',
      metrikaIdReach: 'btn_timetable_duplicate_schedule_month'
    }, {
      name: 'timetableShiftExchange',
      label: 'Shift exchange',
      goTo: '?modal=timetable-shift-exchange',
      metrikaIdReach: 'btn_display_changeShift'
    }]
  }
}, {
  mainButton: {
    name: 'coverage',
    label: 'Coverage',
    tooltip: 'Coverage!',
    goTo: '?coverage=TOGGLE'
  }
}, {
  mainButton: {
    name: 'tableView',
    label: 'Table<br>view',
    tooltip: 'Table view settings',
    menu: [{
      name: 'factualApproved',
      label: 'fact approved',
      goTo: '?tableView=factApproved',
      metrikaIdReach: 'btn_table_view_fact_approved'
    }, {
      name: 'factualTabel',
      label: 'fact/main/additional tabel',
      goTo: '?tableView=factTabel'
    }]
  },
  fastButtons: [{
    name: 'planDraft',
    label: 'plan draft',
    goTo: '?tableView=planBothCompare',
    metrikaIdReach: 'follow_to_plan_bothCompare'
  }, {
    name: 'planApproved',
    label: 'plan approved',
    goTo: '?tableView=planApproved',
    metrikaIdReach: 'follow_to_plan_approved'
  }, {
    name: 'viewPlannedFactual',
    label: 'plan appr. / fact appr.',
    goTo: '?tableView=planFactApprovedCompare',
    metrikaIdReach: 'follow_to_fact_approved'
  }, {
    name: 'factualDraft',
    label: 'fact draft',
    goTo: '?tableView=factBothCompare',
    metrikaIdReach: 'follow_to_fact_bothCompare'
  }]
}, {
  mainButton: {
    name: 'tableDisplayMonth',
    label: 'Display',
    tooltip: 'display by month',
    goTo: '?tableDisplay=month'
  },
  fastButtons: [{
    name: 'tableDisplayWeek',
    label: 'display by week',
    goTo: '?tableDisplay=week',
    metrikaIdReach: 'btn_display_week'
  }, {
    name: 'tableDisplayDay',
    label: 'display by day',
    goTo: '?tableDisplay=day',
    metrikaIdReach: 'btn_display_day'
  }]
}, {
  mainButton: {
    name: 'acceptances',
    label: 'Confirm<br>schedule',
    tooltip: 'Confirm schedule changes',
    allow: 'WorkerDay_approve',
    menu: [{
      name: 'acceptPlanned',
      label: 'plan',
      goTo: '?modal=accept-plan'
    }, {
      name: 'acceptFactual',
      label: 'fact',
      goTo: '?modal=accept-fact'
    }, {
      name: 'acceptRequest',
      label: 'send a request',
      goTo: '?modal=accept-request'
    }]
  }
}, {
  mainButton: {
    name: 'uploadDownload',
    label: 'Upload<br>Download',
    tooltip: 'Uploading and downloading data',
    menu: [{
      name: 'upload',
      label: 'upload schedule',
      goTo: '?modal=upload-schedule'
    }, {
      name: 'download',
      label: 'download "Shift Schedule"',
      goTo: '?modal=download-schedule',
      metrikaIdReach: 'btn_download_timetable_schedule'
    }, {
      name: 'download',
      label: 'download "Tabel"',
      goTo: '?modal=download-tablet',
      metrikaIdReach: 'btn_download_timetable_tablet'
    }, {
      name: 'download',
      label: 'download "The need for staff"',
      goTo: '?modal=download-need',
      metrikaIdReach: 'btn_download_timetable_need'
    }, {
      name: 'download',
      label: 'download "Consolidated report on time worked"',
      goTo: '?modal=download-consolidated',
      metrikaIdReach: 'btn_download_consolidated_report'
    }, {
      name: 'download',
      label: 'download "Tick report"',
      goTo: '?modal=download-tick',
      metrikaIdReach: 'btn_download_tick_report'
    }, {
      name: 'download',
      label: 'download "Schedule deviation report"',
      goTo: '?modal=download-scheduleDeviation',
      metrikaIdReach: 'btn_download_schedule_deviation'
    }]
  }
}];